<template>
  <section v-if="visible" class="pwa-install-prompt" dir="rtl" role="dialog" aria-modal="true" aria-labelledby="pwa-install-title">
    <div class="pwa-install-prompt__card">
      <img class="pwa-install-prompt__logo" src="/logo/android-icon-192x192.png" alt="نشان ایرانی بانک" />
      <span class="pwa-install-prompt__eyebrow">ایرانی بانک همیشه در دسترس</span>
      <h1 id="pwa-install-title">وب‌اپ را نصب کنید</h1>
      <p>با نصب ایرانی بانک، دسترسی سریع‌تری از صفحه اصلی گوشی خواهید داشت.</p>

      <button type="button" class="pwa-install-prompt__primary" :disabled="installing" @click="install">
        {{ installing ? 'در حال آماده‌سازی...' : 'نصب وب‌اپ' }}
      </button>
      <a class="pwa-install-prompt__guide" href="https://irani-bank.com/download-guide.html" target="_blank" rel="noopener noreferrer">راهنمای تصویری نصب</a>
      <button type="button" class="pwa-install-prompt__dismiss" @click="continueWithoutInstall">فعلاً ادامه می‌دهم</button>
    </div>
  </section>
</template>

<script>
const installPromptStorageKey = 'iranibank:pwa-install-prompt-seen'

export default {
  name: 'PwaInstallPrompt',
  data () {
    return {
      visible: false,
      deferredPrompt: null,
      installing: false
    }
  },
  mounted () {
    if (localStorage.getItem(installPromptStorageKey) === '1' || this.isStandalone()) return

    this.visible = true
    window.addEventListener('beforeinstallprompt', this.captureInstallPrompt)
    window.addEventListener('appinstalled', this.handleInstalled)
  },
  beforeUnmount () {
    window.removeEventListener('beforeinstallprompt', this.captureInstallPrompt)
    window.removeEventListener('appinstalled', this.handleInstalled)
  },
  methods: {
    isStandalone () {
      return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true
    },
    captureInstallPrompt (event) {
      event.preventDefault()
      this.deferredPrompt = event
    },
    async install () {
      if (!this.deferredPrompt) {
        window.open('https://irani-bank.com/download-guide.html', '_blank', 'noopener')
        return
      }

      this.installing = true
      try {
        await this.deferredPrompt.prompt()
        const choice = await this.deferredPrompt.userChoice
        if (choice.outcome === 'accepted') this.completePrompt()
      } finally {
        this.installing = false
        this.deferredPrompt = null
      }
    },
    handleInstalled () {
      this.completePrompt()
    },
    continueWithoutInstall () {
      this.completePrompt()
    },
    completePrompt () {
      localStorage.setItem(installPromptStorageKey, '1')
      this.visible = false
    }
  }
}
</script>

<style scoped>
.pwa-install-prompt { position: fixed; z-index: 9000; inset: 0; display: grid; place-items: center; padding: 24px; background: rgba(10, 35, 67, .78); backdrop-filter: blur(9px); font-family: 'IRANSansXFaNum-Light', sans-serif; }
.pwa-install-prompt__card { width: min(100%, 420px); padding: 32px 24px 24px; border: 1px solid rgba(255, 255, 255, .72); border-radius: 28px; background: linear-gradient(145deg, #fff, #eff6ff); box-shadow: 0 24px 70px rgba(0, 0, 0, .28); text-align: center; }
.pwa-install-prompt__logo { display: block; width: 82px; height: 82px; margin: 0 auto 14px; object-fit: contain; }
.pwa-install-prompt__eyebrow { color: #3d78c5; font-size: 13px; font-weight: 700; }
.pwa-install-prompt h1 { margin: 8px 0 10px; color: #1f2f4d; font-size: 25px; font-weight: 800; }
.pwa-install-prompt p { margin: 0 auto 22px; color: #5d6b83; font-size: 14px; line-height: 2; }
.pwa-install-prompt__primary, .pwa-install-prompt__dismiss { width: 100%; border: 0; border-radius: 12px; min-height: 50px; font-family: inherit; font-size: 15px; font-weight: 700; cursor: pointer; }
.pwa-install-prompt__primary { color: #fff; background: #3679ce; box-shadow: 0 10px 22px rgba(54, 121, 206, .26); }
.pwa-install-prompt__primary:disabled { cursor: wait; opacity: .68; }
.pwa-install-prompt__guide { display: inline-block; margin: 17px 0 8px; color: #3268bd; font-size: 14px; font-weight: 700; text-decoration: none; }
.pwa-install-prompt__dismiss { color: #61708b; background: transparent; }
</style>
